// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero_hero__1924p","content":"hero_content__21Raa"};